export function numberedProposal(currentModelNames: string[], proposal: string) {
  if (currentModelNames.find((title) => title === proposal)) {
    const sameNames = currentModelNames.filter((title) => title?.startsWith(proposal + " "));
    let highestNumber = 1;
    for (const title of sameNames) {
      const number = Number(title.substring(proposal.length + 1));
      if (number) {
        highestNumber = Math.max(highestNumber, number);
      }
    }
    proposal = proposal + " " + String(highestNumber + 1);
  }

  return proposal;
}
